<template>
    <div>
        <div v-if="cart.id !== null && cart.places.length > 0" class="summary">
            <div class="row">
                <div class="col">
                    <h3
                        class="m-0"
                        v-html="trans('user.cart.summary.title')"
                    ></h3>
                </div>
            </div>
            <template v-for="(place, place_index) in cart.places">
                <hr :key="place_index + '_HR'" />
                <div class="row" :key="place_index + '_PLACE'">
                    <div class="col text-truncate font-weight-bold">
                        {{ place.name }}
                    </div>
                </div>
                <template v-for="(course, course_index) in place.courses">
                    <div class="row" :key="course_index + '_' + course.id">
                        <div
                            class="col text-truncate font-weight-bold"
                            :title="course.name"
                        >
                            {{ course.name }}
                        </div>
                    </div>
                    <div
                        v-for="(date, date_index) in course.dates"
                        v-bind:key="
                            place_index + '_' + course_index + '_' + date_index
                        "
                        v-bind:item="date"
                    >
                        <div class="pl-3">
                            {{
                                summaryDate(
                                    date.event.start_datetime,
                                    date.event.timezone
                                )
                            }}
                            <div
                                v-for="(ticket, ticket_index) in date.items"
                                v-bind:key="
                                    place_index +
                                    '_' +
                                    course_index +
                                    '_' +
                                    date_index +
                                    '_' +
                                    ticket_index
                                "
                                v-bind:item="ticket"
                            >
                                <div class="row">
                                    <template v-if="ticket.coupon != null || ticket.is_last_minute">
                                        <div class="col-7">
                                            <div
                                                class="pl-3 text-truncate"
                                                :title="ticket.title"
                                            >
                                                {{ ticket.title }}
                                                <span v-if="ticket.is_last_minute" class="badge badge-success">Last Minute</span>
                                            </div>
                                        </div>
                                        <div class="col-2 text-right px-0">
                                            <div class="old-price">
                                                <del>
                                                    {{
                                                        formatPrice(
                                                            ticket.price *
                                                                ticket.quantity,
                                                            ticket.currency.code
                                                        )
                                                    }}
                                                </del>
                                            </div>
                                        </div>
                                        <div class="col-3 text-right pl-0">
                                            <div class="new-price">
                                                {{
                                                    formatPrice(
                                                        ticket.discounted_price *
                                                            ticket.quantity,
                                                        ticket.currency.code
                                                    )
                                                }}
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="col-8">
                                            <div
                                                class="pl-3 text-truncate"
                                                :title="ticket.title"
                                            >
                                                {{ ticket.title }}
                                            </div>
                                        </div>
                                        <div class="col-4 text-right">
                                            {{
                                                formatPrice(
                                                    ticket.price *
                                                        ticket.quantity,
                                                    ticket.currency.code
                                                )
                                            }}
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-for="(pack, pack_index) in place.packs">
                    <div class="row" :key="pack_index">
                        <div class="col-8">
                            <div
                                class="text-truncate font-weight-bold"
                                :title="pack.title"
                            >
                                {{ pack.name }}
                            </div>
                        </div>
                        <div class="col-2 text-right px-0">
                            <div class="old-price">
                                <del>
                                    {{
                                        formatPrice(
                                            pack.basePrice * pack.quantity,
                                            pack.currency.code
                                        )
                                    }}
                                </del>
                            </div>
                        </div>
                        <div class="col-2 text-right pl-0">
                            <div v-if="pack.coupon != null" class="new-price">
                                {{
                                    formatPrice(
                                        pack.discountedPrice * pack.quantity,
                                        pack.currency.code
                                    )
                                }}
                            </div>
                            <div v-else class="new-price">
                                {{
                                    formatPrice(
                                        pack.price * pack.quantity,
                                        pack.currency.code
                                    )
                                }}
                            </div>
                        </div>
                    </div>
                    <div
                        v-for="(course, course_index) in pack.courses"
                        v-bind:key="
                            place_index + '_' + pack_index + ' ' + course_index
                        "
                        v-bind:item="course"
                    >
                        <div class="pl-3">
                            <div class="row">
                                <div class="col">
                                    <div
                                        class="text-truncate"
                                        :title="course.name"
                                    >
                                        {{ course.name }}
                                    </div>
                                </div>
                            </div>
                            <span class="pl-3" v-if="pack.events">
                                {{
                                    summaryDate(
                                        pack.events[course_index]
                                            .start_datetime,
                                        pack.events[course_index].timezone
                                    )
                                }}
                            </span>
                        </div>
                    </div>
                </template>
            </template>
            <template v-if="cart.subtotal != cart.total">
                <div class="mb-4 pt-1">
                    <hr />
                    <div class="row">
                        <div
                            class="col-8 subtotal-summary"
                            v-html="trans('user.cart.total_item.base_price')"
                        ></div>
                        <div class="col-4 text-right subtotal-summary price">
                            {{ formatPrice(cart.subtotal, cart.currency.code) }}
                        </div>
                    </div>
                    <template v-for="giftCard in cart.gift_cards">
                        <div class="row mt-2" v-bind:key="giftCard.code">
                            <div
                                class="col-1 text-left remove-icon"
                                v-if="editable"
                            >
                                <i
                                    class="fas fa-times-circle"
                                    :title="trans('user.cart.gift_card.remove')"
                                    v-on:click="removeGiftCard(giftCard.code)"
                                ></i>
                            </div>
                            <div class="col-7">
                                <span
                                    v-html="
                                        trans('user.cart.total_item.gift_card')
                                    "
                                ></span>
                                {{ giftCard.code }}
                            </div>

                            <div
                                class="col-4 text-right subtotal-summary price"
                            >
                                -&nbsp;{{
                                    formatPrice(
                                        giftCard.used_amount,
                                        cart.currency.code
                                    )
                                }}
                            </div>
                        </div>
                    </template>
                </div>
            </template>
            <hr />
            <div class="row pt-1 mb-4">
                <div
                    class="col-8 total-summary"
                    v-html="trans('user.cart.total') + ':'"
                ></div>
                <div class="col-4 text-right total-summary price">
                    {{ formatPrice(cart.total, cart.currency.code) }}
                </div>
            </div>

            <div class="row" v-if="editable">
                <div class="col mb-4">
                    <button
                        class="input-button-voucher"
                        type="button"
                        data-toggle="modal"
                        data-target="#gift-card-modal"
                        v-html="trans('user.cart.gift_card.enter')"
                    ></button>
                </div>
            </div>
            <div class="row" v-if="editable">
                <div class="col">
                    <div class="input-discount-code">
                        <input
                            type="text"
                            class="input-discount-code-text"
                            :placeholder="trans('user.cart.coupon.enter')"
                            v-model="couponCode"
                        />
                        <div class="input-group-append">
                            <button
                                class="input-discount-code-submit"
                                type="button"
                                v-on:click="submitCoupon()"
                                v-html="trans('user.cart.coupon.apply')"
                            ></button>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="coupons.length">
                <div class="row mt-3 mb-1">
                    <div
                        class="col"
                        v-html="trans('user.cart.coupon.codes') + ':'"
                    ></div>
                </div>
            </template>
            <template v-for="coupon in coupons">
                <div class="row" v-bind:key="coupon.code">
                    <div class="col">
                        <div class="summary-coupon">
                            <div class="summary-coupon-code">
                                {{ coupon.code }}
                            </div>
                            <div
                                class="fas fa-times"
                                v-if="editable"
                                v-on:click="removeCoupon(coupon)"
                                :title="trans('user.cart.coupon.remove')"
                            ></div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        cart: Object,
        coupons: Array,
        editable: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        let guessedTimeZone = app.lib.moment.tz.guess(true);
        return {
            couponCode: null,
            currencies: [],
            guessedTimeZone: guessedTimeZone,
        };
    },

    created() {
        this.token = document.querySelector('meta[name="csrf-token"]').content;
    },

    methods: {
        summaryDate(date, timezone) {
            let momentDate = app.lib.moment.tz(
                date.substring(0, 10) + ' ' + date.substring(11, 19),
                timezone
            );
            let dayName = momentDate.tz(this.guessedTimeZone).format('ddd');
            date = momentDate.tz(this.guessedTimeZone).format('ll');

            return dayName + ' ' + date;
        },

        submitCoupon() {
            if (this.couponCode != null && this.couponCode != '') {
                this.$parent.loading = true;
                axios
                    .post(
                        '/api/carts/coupons/use',
                        {
                            code: this.couponCode,
                        },
                        {
                            headers: {
                                'X-CSRF-TOKEN': this.$parent.token,
                            },
                        }
                    )
                    .then(
                        (success) => {
                            if (success.data.success) {
                                // Update global data for further events.
                                appData.page.vars.gtmData =
                                    success.data.gtmData;
                                success.data.gtmData.promotion_id =
                                    this.couponCode;

                                // Trigger GTM event.
                                this.app.gtm.trigger(
                                    'select_promotion',
                                    success.data.gtmData
                                );

                                // Reloading the cart
                                this.$parent.loadCart();
                            } else {
                                // Show a message to the user
                                this.$parent.loading = false;
                            }

                            this.$parent.$refs.alertBox.showAlertMessage(
                                success.data.success ? 'success' : 'warning',
                                this.trans(success.data.message, {
                                    ':couponCode': success.data.data,
                                    ':currencyAllowed':
                                        success.data.currencyAllowed,
                                })
                            );
                        },
                        (error) => {
                            this.$parent.$refs.alertBox.handleError(error);
                        }
                    );
            }
        },

        removeCoupon(coupon) {
            this.$parent.loading = true;
            axios
                .delete('/api/carts/coupons/' + coupon.code, {
                    headers: {
                        'X-CSRF-TOKEN': this.$parent.token,
                    },
                })
                .then(
                    (success) => {
                        if (success.data.success) {
                            // Update global data for further events.
                            appData.page.vars.gtmData = success.data.gtmData;
                            // Trigger GTM event.
                            this.app.gtm.trigger(
                                'removeCoupon',
                                success.data.gtmData
                            );

                            // Reloading the cart
                            this.$parent.loadCart();
                        } else {
                            // Show a message to the user
                            this.$parent.loading = false;
                        }

                        this.$parent.$refs.alertBox.showAlertMessage(
                            success.data.success ? 'success' : 'warning',
                            this.trans(success.data.message, {
                                ':couponCode': success.data.data,
                                ':currencyAllowed':
                                    success.data.currencyAllowed,
                            })
                        );
                    },
                    (error) => {
                        this.$parent.$refs.alertBox.handleError(error);
                    }
                );
        },

        removeGiftCard(giftCardCode) {
            this.$parent.loading = true;
            axios
                .delete('/api/carts/gift-cards/remove/' + giftCardCode, {
                    headers: {
                        'X-CSRF-TOKEN': this.$parent.token,
                    },
                })
                .then(
                    (success) => {
                        // Update global data for further events.
                        appData.page.vars.gtmData = success.data.gtmData;

                        // Trigger GTM event.
                        this.app.gtm.trigger(
                            'removeGiftCard',
                            appData.page.vars.gtmData
                        );

                        if (success.data.success) {
                            // Reloading the cart
                            this.$parent.loadCart();
                        } else {
                            // Show a message to the user
                            this.$parent.loading = false;
                        }

                        this.$parent.$refs.alertBox.showAlertMessage(
                            success.data.success ? 'success' : 'warning',
                            this.trans(success.data.message, {
                                ':code': success.data.data,
                            })
                        );
                    },
                    (error) => {
                        this.$parent.$refs.alertBox.handleError(error.response);
                    }
                );
        },

        formatPrice(price, currencyCode) {
            return window.app.formatPrice(price, currencyCode);
        },
    },
};
</script>
